import getEffectiveUsage from '../getEffectiveUsage';

import type { GetUnitBaselines } from './types';

const RESETTING_EVENT_TYPES: string[] = ['REPLACED', 'SERVICED'];

const FIRST_UNIT_INDEX = 1;

const NO_BASELINE = 0;

const getUnitBaselines: GetUnitBaselines = ({ intervalUnit, logs, partType, unitCount }) => {
    const resettingLogs = logs.filter(
        log => log.partType === partType && RESETTING_EVENT_TYPES.includes(log.eventType)
    );

    const unitIndexes = Array.from(
        { length: Math.max(unitCount, NO_BASELINE) },
        (_unit, offset) => offset + FIRST_UNIT_INDEX
    );

    return unitIndexes.map(unitIndex => {
        const usages = resettingLogs
            .filter(
                log =>
                    log.unitIndex === undefined ||
                    log.unitIndex === null ||
                    log.unitIndex === unitIndex
            )
            .map(log => getEffectiveUsage({ counters: log.usageAtEvent, intervalUnit }))
            .filter((usage): usage is number => usage !== null);

        return {
            baseline: usages.length ? Math.max(...usages) : NO_BASELINE,
            unitIndex
        };
    });
};

export default getUnitBaselines;
